import { render, staticRenderFns } from "./MessageCard_type.vue?vue&type=template&id=351cc944&"
import script from "./MessageCard_type.vue?vue&type=script&lang=js&"
export * from "./MessageCard_type.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports